<template>
  <div>
    <h4>View word (<b>{{this.lexiconWord}}</b>)</h4><br />
    <div class="form-group">
        <table style="border-collapse: separate; border-spacing: 5px">
          <tbody>
            <tr v-for="item in renderProps" :key="item.key">
              <td class="text-center align-middle" :style="{ width: '65%', 'vertical-align': 'middle', 'background-color': item.color ? item.color : '#000000'}" style="color: black;">
                <h3 v-show="!item.showEdit" style="font-family: consolaB">&nbsp;{{item.guide}}&nbsp;</h3>
              </td>
              <td class="text-center" :style="{ 'color': 'black', 'background-color': item.color ? item.color : '#FFFFFF' }">
                <h3 style="font-family: consolaI">&nbsp;&nbsp;<b>{{item.phoneme}}</b>&nbsp;&nbsp;</h3>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <div class="float-left">
      <button class="btn btn-danger" @click.stop="$router.go(-1)">Back</button>&nbsp;
      <button class="btn btn-success" @click.stop="$router.push({ name: 'LexiconWordsEdit', params: {id: wordId, word: lexiconWord }})">Edit</button>
      <img v-if="loadingEasy" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" /><br />
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import router from '../router'

export default {
  name: 'LexiconWordsAdd',
  data: function () {
    return {
      lexiconWord: '',
      wordId: this.$route.params.id,
      loadingEasy: false,
      loadingEasyUserGuide: false,
      emptyGuideMsg: '',
      showProposeGuide: false,
      proposedGuide: '',
      saveState: 0,
      renderProps: []
    }
  },
  props: [],
  mounted: function () {
    if (!this.$route.params.id) {
      router.push({ name: 'Lexicons' })
    } else {
      apiClient.get('/api/lexicons/word/view/' + this.$route.params.id).then((response) => {
        this.lexiconWord = response.data.word.word

        if (!response.data.word.guides || response.data.word.guides.length === 0) {
          return this.onGeneratePhoneme()
        }

        const lexiconGuides = response.data.word.guides.split(',')
        const lexiconPhonemes = response.data.word.phonemes.split(',')
        const lexiconColors = response.data.word.colors.split(',')

        for (let i = 0; i < lexiconGuides.length; i++) {
          const obj = {}
          obj.key = i
          obj.guide = lexiconGuides[i]
          obj.showEdit = false
          obj.phoneme = lexiconPhonemes[i]
          obj.color = lexiconColors[i]
          obj.loadingEditGuideState = false

          this.renderProps.push(obj)
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  },
  methods: {
    onGeneratePhoneme: function () {
      if (!this.lexiconWord.trim()) {
        return false
      }

      this.lexiconWord = this.lexiconWord.split(' ').join('_')
      this.loadingEasy = true
      this.renderProps = []
      this.showProposeGuide = false
      this.proposedGuide = ''
      this.emptyGuideMsg = false

      apiClient.get('/api/lexicons/props/' + this.lexiconWord).then((response) => {
        if (response.data.lexicon_guides.length === 0) {
          this.emptyGuideMsg = true
          return
        }
        const lexiconGuides = response.data.lexicon_guides
        const lexiconPhonemes = response.data.lexicon_phonemes
        const lexiconColors = this.$randomColor({ count: lexiconGuides.length, luminosity: 'light', hue: 'random' })

        for (let i = 0; i < lexiconGuides.length; i++) {
          const obj = {}
          obj.key = i
          obj.guide = lexiconGuides[i]
          obj.showEdit = false
          obj.phoneme = lexiconPhonemes[i]
          obj.color = lexiconColors[i]
          obj.loadingEditGuideState = false

          this.renderProps.push(obj)
        }

        this.loadingEasy = false
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  }
}
</script>
